// extracted by mini-css-extract-plugin
export default {"root":"CXPBJ8","bg":"uC0LwE"};